import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HeaderThree = () => {
    const [active, setActive] = useState(false);
    const [search, setSearch] = useState(false);
    const [sidebar, setSidebar] = useState(false);
    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        let offCanvasNav = document.getElementById('offcanvas-navigation');
        let offCanvasNavSubMenu = offCanvasNav.querySelectorAll('.sub-menu');

        for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
            offCanvasNavSubMenu[i].insertAdjacentHTML(
                'beforebegin',
                '<span class=\'mean-expand-class\'>+</span>',
            );
        }

        let menuExpand = offCanvasNav.querySelectorAll('.mean-expand-class');
        let numMenuExpand = menuExpand.length;

        function sideMenuExpand() {
            if (this.parentElement.classList.contains('active') === true) {
                this.parentElement.classList.remove('active');
            } else {
                for (let i = 0; i < numMenuExpand; i++) {
                    menuExpand[i].parentElement.classList.remove('active');
                }
                this.parentElement.classList.add('active');
            }
        }

        for (let i = 0; i < numMenuExpand; i++) {
            menuExpand[i].addEventListener('click', sideMenuExpand);
        }
        window.onscroll = () => {
            if (window.pageYOffset < 250) {
                setScroll(false);
            } else if (window.pageYOffset > 250) {
                setScroll(true);
            }
            return () => (window.onscroll = null);
        };
    }, []);

    const mobileMenu = () => {
        setActive(!active);
    };

    const sidebarControl = (active) => {
        setSidebar(active);
    };
    return (
        <>
            <div
                className={`sidemenu-wrapper sidemenu-info ${sidebar ? 'show' : ''} `}
            >
                <div className="sidemenu-content">
                    <button
                        className="closeButton sideMenuCls"
                        onClick={() => sidebarControl(false)}
                    >
                        <i className="fas fa-times"/>
                    </button>
                    <div className="widget  ">
                        <div className="th-widget-about">
                            <div className="about-logo">
                                <Link to="/">
                                    <img src="assets/img/logo.svg" alt="Laun"/>
                                </Link>
                            </div>
                            <p className="about-text">
                                We provide specialized winterization services to safeguard your
                                pool during the off-season, and when spring arrives, we handle
                                the thorough opening process.
                            </p>
                            <div className="social-links">
                                <Link to="https://www.xiaohongshu.com/user/profile/66b78a76000000001e009e15?xhsshare=CopyLink&appuid=66b78a76000000001e009e15&apptime=1725521899">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 25" id="xhs">
                                        <g clip-path="url(#xhs_clip0_14651_19727)">
                                            <path d="M13.969 17H6.03A3.032 3.032 0 013 13.97V6.032A3.032 3.032 0 016.031 3h7.938A3.032 3.032 0 0117 6.032v7.937A3.032 3.032 0 0113.969 17z" fill="#FF2442"></path>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M15.276 10.24a.594.594 0 00-.317-.44.822.822 0 00-.388-.097h-.078c-.019 0-.019 0-.019-.02v-.012-.453c0-.058 0-.116-.013-.174a.705.705 0 00-.362-.55.949.949 0 00-.44-.116h-.316c-.032 0-.032 0-.032-.026v-.22c0-.006 0-.013-.007-.013-.006-.006-.013 0-.013 0h-.672-.013s-.006.007-.006.013v.239c0 .007-.007.007-.013.007H12.14c-.013 0-.013.006-.013.013v.653c0 .038 0 .038.039.038h.4c.04 0 .033.059.033.059v.51s0 .052-.026.052h-.653c-.032 0-.026.039-.026.039v.64s-.006.032.026.032h.64c.039 0 .032 0 .032.032V11.875c0 .038 0 .038.039.038h.633c.04 0 .04 0 .04-.038v-1.422-.026c0-.013 0-.013.012-.013h1.028c.045 0 .084.006.123.026a.205.205 0 01.122.18v.524c0 .117-.045.162-.142.162h-.536c-.013 0-.013 0-.013.013 0 .006.207.478.246.575v.006c0 .007.012.013.019.013h.226c.065 0 .226 0 .29-.006.06-.007.124-.013.182-.032a.597.597 0 00.427-.582v-.88a1.39 1.39 0 00-.013-.174zm-1.5-.55c0 .006-.006.013-.006.013h-.453c-.006 0-.006-.007-.013-.013v-.026l-.006-.55c0-.032 0-.032.032-.032h.323c.02 0 .039 0 .052.007.045.013.071.045.071.09v.511zm-1.842 1.519c0-.007-.006-.007-.013-.007h-.64c-.02 0-.02 0-.02-.019V9.108c0-.032 0-.032.033-.032h.381c.033 0 .033 0 .033-.032v-.64c0-.04 0-.033-.033-.033h-1.544c-.026 0-.033 0-.033.033v.64c0 .038 0 .032.033.032h.374c.033 0 .033 0 .033.032v2.049c0 .039 0 .039-.039.039h-.575c-.02 0-.026.013-.026.013l-.31.672-.007.013c0 .006.007.006.026.006h2.308c.013 0 .013 0 .013-.013v-.012-.647c.006-.006.006-.013.006-.02zM6.737 8.152h-.665a.014.014 0 00-.013.013c0 .168-.007 1.79-.007 2.61v.415c0 .129-.116.116-.123.116h-.323c-.02 0-.02 0-.02.02 0 .019.208.471.246.555.007.006.013.013.026.013.071 0 .336.006.414-.007a.555.555 0 00.194-.058.58.58 0 00.265-.336.737.737 0 00.032-.239V9.73c0-.485 0-1.448-.006-1.57-.007 0-.013-.007-.02-.007zm3.057 2.184h-.387c-.04 0-.065-.039-.052-.077l.517-1.164c.007-.006 0-.013-.013-.013h-.582c-.045 0-.077-.051-.058-.09l.388-.866c.007-.007 0-.013-.013-.013H8.91c-.006 0-.006 0-.013.006l-.407.918c-.039.084-.084.168-.116.252-.02.052-.046.104-.059.162a.186.186 0 00-.006.084c.006.07.039.13.103.168.02.013.04.02.058.026a.38.38 0 00.15.026h.258c.013 0-.259.588-.304.704a1.8 1.8 0 00-.065.168c-.006.026-.013.052-.006.078a.21.21 0 00.103.174c.02.013.039.02.058.026a.38.38 0 00.149.026h.731c.006 0 .006 0 .012-.006l.252-.57c0-.006-.006-.019-.013-.019zm-1.7.407a.64.64 0 01-.058-.271c0-.045-.006-.084-.006-.13-.006-.064-.013-.129-.013-.193-.006-.071-.013-.142-.013-.213a23.42 23.42 0 00-.02-.207 2.086 2.086 0 01-.012-.2 1.951 1.951 0 01-.013-.195c-.007-.07-.013-.142-.013-.213 0-.013 0-.032-.007-.039 0-.006-.025-.006-.032-.006h-.653c-.013 0-.013 0-.013.013.007.045.007.084.013.13.007.096.013.187.026.283l.02.22c.006.104.013.2.025.304.007.116.02.233.026.35.007.05.007.096.013.148.013.11.033.22.065.323.039.149.084.29.155.433.045.097.097.187.162.265.006.006.012.026.019.02 0 0 0-.007.006-.007.04-.084.33-.73.35-.776-.013-.02-.02-.013-.026-.039zM5.568 9.076h-.685c-.006 0-.006 0-.006.006 0 0 0 .026-.007.033a2.362 2.362 0 00-.013.213c-.006.065-.013.13-.013.194a2.086 2.086 0 00-.012.2l-.02.207c-.006.071-.013.142-.013.213a1.95 1.95 0 00-.013.194c-.006.046-.006.084-.006.13a.661.661 0 01-.058.271c-.013.026-.013.02 0 .052.019.039.303.672.349.769l.006.006c.007 0 .013-.013.02-.019.064-.084.116-.175.161-.265.065-.136.116-.284.155-.433.026-.11.045-.213.065-.323.006-.045.006-.097.013-.149.006-.116.02-.233.026-.349.006-.103.013-.2.026-.304l.019-.22a4.22 4.22 0 01.026-.284c.006-.045.006-.084.013-.13-.02-.006-.02-.012-.033-.012zm3.943 2.12h-.743a.996.996 0 01-.336-.058c-.007 0-.013 0-.013.006l-.317.685c0 .007 0 .013.007.013a.58.58 0 00.22.052H9.2c.006 0 .006 0 .013-.007l.31-.678c0-.007-.006-.013-.013-.013zm5.08-2.12H14.933c.026 0 .052 0 .078-.007a.357.357 0 00.271-.42.352.352 0 00-.388-.271.354.354 0 00-.304.349v.343c-.006 0 0 .006 0 .006z"
                                                  fill="#fff"></path>
                                        </g>
                                    </svg>
                                </Link>
                                <Link to="https://v.douyin.com/ih4pcFs4/ 4@5.com">
                                    <i className="fab fa-tiktok"/>
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-weixin"/>
                                </Link>
                                <Link to="#">
                                    <i className="fa fa-phone"/>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="side-info mb-30">
                        <div className="contact-list mb-20">
                            <h4>Office Address</h4>
                            <p>1212, Lav Vegas, The Veg Street, USA</p>
                        </div>
                        <div className="contact-list mb-20">
                            <h4>Phone Number</h4>
                            <p className="mb-0">+880 123 45 67 89</p>
                            <p>+880 765 86 43 85</p>
                        </div>
                        <div className="contact-list mb-20">
                            <h4>Email Address</h4>
                            <p className="mb-0">yourmail@gmail.com</p>
                            <p>example.mail@hum.com</p>
                        </div>
                    </div>
                    <ul className="side-instagram list-wrap">
                        <li>
                            <Link to="#">
                                <img src="assets/img/gallery/1.jpg" alt="Bizmaster"/>
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <img src="assets/img/gallery/2.jpg" alt="Bizmaster"/>
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <img src="assets/img/gallery/3.jpg" alt="Bizmaster"/>
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <img src="assets/img/gallery/4.jpg" alt="Bizmaster"/>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            {/*==============================
      Mobile Menu
      ============================== */}
            <div className={`mobile-menu-wrapper ${active ? 'body-visible' : ''}`}>
                <div className="mobile-menu-area">
                    <div className="mobile-logo">
                        <Link to="/">
                            <img src="assets/img/logo.svg" alt="Bizmaster"/>
                        </Link>
                        <button className="menu-toggle" onClick={mobileMenu}>
                            <i className="fa fa-times"/>
                        </button>
                    </div>
                    <div className="mobile-menu">
                        <ul id="offcanvas-navigation">
                            <li>
                                <Link to="/">首页</Link>
                            </li>

                            <li>
                                <Link to="/about">关于我们</Link>
                            </li>
                            <li>
                                <Link to="/service-details">服务内容</Link>
                            </li>
                            <li>
                                <Link to="/project">客户案例</Link>
                            </li>
                            <li>
                                <Link to="/pricing">获取报价</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Header Area */}

            <header className="nav-header header-layout3">
                <div className="header-top d-none d-lg-block">
                    <div className="container">
                        <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
                            <div className="col-auto">
                                <div className="header-links">
                                    <ul>
                                        <li>
                                            <i className="fas fa-envelope"/>
                                            <Link to="mailto:info@wafuuweb.com">info@wafuuweb.com</Link>
                                        </li>
                                        <li>
                                            <i className="fas fa-phone-alt"/>
                                            <Link to="tel:+8618657585960">WeChat: wafuuweb</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="header-links ps-0">
                                    <ul>
                                        <li>
                                            <div className="social-links">
                                                <Link to="https://www.xiaohongshu.com/user/profile/66b78a76000000001e009e15?xhsshare=CopyLink&appuid=66b78a76000000001e009e15&apptime=1725521899">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 25" id="xhs">
                                                        <g clip-path="url(#xhs_clip0_14651_19727)">
                                                            <path d="M13.969 17H6.03A3.032 3.032 0 013 13.97V6.032A3.032 3.032 0 016.031 3h7.938A3.032 3.032 0 0117 6.032v7.937A3.032 3.032 0 0113.969 17z" fill="#FF2442"></path>
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M15.276 10.24a.594.594 0 00-.317-.44.822.822 0 00-.388-.097h-.078c-.019 0-.019 0-.019-.02v-.012-.453c0-.058 0-.116-.013-.174a.705.705 0 00-.362-.55.949.949 0 00-.44-.116h-.316c-.032 0-.032 0-.032-.026v-.22c0-.006 0-.013-.007-.013-.006-.006-.013 0-.013 0h-.672-.013s-.006.007-.006.013v.239c0 .007-.007.007-.013.007H12.14c-.013 0-.013.006-.013.013v.653c0 .038 0 .038.039.038h.4c.04 0 .033.059.033.059v.51s0 .052-.026.052h-.653c-.032 0-.026.039-.026.039v.64s-.006.032.026.032h.64c.039 0 .032 0 .032.032V11.875c0 .038 0 .038.039.038h.633c.04 0 .04 0 .04-.038v-1.422-.026c0-.013 0-.013.012-.013h1.028c.045 0 .084.006.123.026a.205.205 0 01.122.18v.524c0 .117-.045.162-.142.162h-.536c-.013 0-.013 0-.013.013 0 .006.207.478.246.575v.006c0 .007.012.013.019.013h.226c.065 0 .226 0 .29-.006.06-.007.124-.013.182-.032a.597.597 0 00.427-.582v-.88a1.39 1.39 0 00-.013-.174zm-1.5-.55c0 .006-.006.013-.006.013h-.453c-.006 0-.006-.007-.013-.013v-.026l-.006-.55c0-.032 0-.032.032-.032h.323c.02 0 .039 0 .052.007.045.013.071.045.071.09v.511zm-1.842 1.519c0-.007-.006-.007-.013-.007h-.64c-.02 0-.02 0-.02-.019V9.108c0-.032 0-.032.033-.032h.381c.033 0 .033 0 .033-.032v-.64c0-.04 0-.033-.033-.033h-1.544c-.026 0-.033 0-.033.033v.64c0 .038 0 .032.033.032h.374c.033 0 .033 0 .033.032v2.049c0 .039 0 .039-.039.039h-.575c-.02 0-.026.013-.026.013l-.31.672-.007.013c0 .006.007.006.026.006h2.308c.013 0 .013 0 .013-.013v-.012-.647c.006-.006.006-.013.006-.02zM6.737 8.152h-.665a.014.014 0 00-.013.013c0 .168-.007 1.79-.007 2.61v.415c0 .129-.116.116-.123.116h-.323c-.02 0-.02 0-.02.02 0 .019.208.471.246.555.007.006.013.013.026.013.071 0 .336.006.414-.007a.555.555 0 00.194-.058.58.58 0 00.265-.336.737.737 0 00.032-.239V9.73c0-.485 0-1.448-.006-1.57-.007 0-.013-.007-.02-.007zm3.057 2.184h-.387c-.04 0-.065-.039-.052-.077l.517-1.164c.007-.006 0-.013-.013-.013h-.582c-.045 0-.077-.051-.058-.09l.388-.866c.007-.007 0-.013-.013-.013H8.91c-.006 0-.006 0-.013.006l-.407.918c-.039.084-.084.168-.116.252-.02.052-.046.104-.059.162a.186.186 0 00-.006.084c.006.07.039.13.103.168.02.013.04.02.058.026a.38.38 0 00.15.026h.258c.013 0-.259.588-.304.704a1.8 1.8 0 00-.065.168c-.006.026-.013.052-.006.078a.21.21 0 00.103.174c.02.013.039.02.058.026a.38.38 0 00.149.026h.731c.006 0 .006 0 .012-.006l.252-.57c0-.006-.006-.019-.013-.019zm-1.7.407a.64.64 0 01-.058-.271c0-.045-.006-.084-.006-.13-.006-.064-.013-.129-.013-.193-.006-.071-.013-.142-.013-.213a23.42 23.42 0 00-.02-.207 2.086 2.086 0 01-.012-.2 1.951 1.951 0 01-.013-.195c-.007-.07-.013-.142-.013-.213 0-.013 0-.032-.007-.039 0-.006-.025-.006-.032-.006h-.653c-.013 0-.013 0-.013.013.007.045.007.084.013.13.007.096.013.187.026.283l.02.22c.006.104.013.2.025.304.007.116.02.233.026.35.007.05.007.096.013.148.013.11.033.22.065.323.039.149.084.29.155.433.045.097.097.187.162.265.006.006.012.026.019.02 0 0 0-.007.006-.007.04-.084.33-.73.35-.776-.013-.02-.02-.013-.026-.039zM5.568 9.076h-.685c-.006 0-.006 0-.006.006 0 0 0 .026-.007.033a2.362 2.362 0 00-.013.213c-.006.065-.013.13-.013.194a2.086 2.086 0 00-.012.2l-.02.207c-.006.071-.013.142-.013.213a1.95 1.95 0 00-.013.194c-.006.046-.006.084-.006.13a.661.661 0 01-.058.271c-.013.026-.013.02 0 .052.019.039.303.672.349.769l.006.006c.007 0 .013-.013.02-.019.064-.084.116-.175.161-.265.065-.136.116-.284.155-.433.026-.11.045-.213.065-.323.006-.045.006-.097.013-.149.006-.116.02-.233.026-.349.006-.103.013-.2.026-.304l.019-.22a4.22 4.22 0 01.026-.284c.006-.045.006-.084.013-.13-.02-.006-.02-.012-.033-.012zm3.943 2.12h-.743a.996.996 0 01-.336-.058c-.007 0-.013 0-.013.006l-.317.685c0 .007 0 .013.007.013a.58.58 0 00.22.052H9.2c.006 0 .006 0 .013-.007l.31-.678c0-.007-.006-.013-.013-.013zm5.08-2.12H14.933c.026 0 .052 0 .078-.007a.357.357 0 00.271-.42.352.352 0 00-.388-.271.354.354 0 00-.304.349v.343c-.006 0 0 .006 0 .006z"
                                                                  fill="#fff"></path>
                                                        </g>
                                                    </svg>
                                                </Link>
                                                <Link to="https://v.douyin.com/ih4pcFs4/ 4@5.com">
                                                    <i className="fab fa-tiktok"/>
                                                </Link>
                                                <Link to="#" className="wechat-qr-warp">
                                                    <i className="fab fa-weixin"/>
                                                    <div className="wechat-qr-img">
                                                        <img className="wechat-qr" src="/assets/img/wechat_qr.png" alt="wechat qr"/>
                                                    </div>
                                                </Link>
                                                <Link to="tel:+8618657585960">
                                                    <i className="fa fa-phone"/>
                                                </Link>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="header-top-bg-shape"></div>
                </div>
                <div className={`sticky-wrapper ${scroll && 'sticky'}`}>
                    {/* Main Menu Area */}
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-auto">
                                <div className="header-logo">
                                    <Link to="/">
                                        <img src="assets/img/logo.svg" alt="logo"/>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-auto">
                                <nav className="main-menu d-none d-lg-inline-block">
                                    <ul>
                                        <li>
                                            <Link to="/">首页</Link>
                                        </li>

                                        <li>
                                            <Link to="/about">关于我们</Link>
                                        </li>
                                        <li>
                                            <Link to="/service">服务内容</Link>
                                        </li>
                                        <li>
                                            <Link to="/project">客户案例</Link>
                                        </li>
                                        <li>
                                            <Link to="/pricing">获取报价</Link>
                                        </li>
                                    </ul>
                                </nav>
                                <div className="navbar-right d-inline-flex d-lg-none">
                                    <button
                                        type="button"
                                        className="menu-toggle icon-btn"
                                        onClick={mobileMenu}
                                    >
                                        <i className="fas fa-bars"/>
                                    </button>
                                </div>
                            </div>
                            <div className="col-auto ms-xxl-4 d-xl-block d-none">
                                <div className="header-wrapper">
                                    <div className="header-button">
                                        <Link to="/contact" className="global-btn style-border">
                                            联系我们
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default HeaderThree;
